import { render, staticRenderFns } from "./CollabCourses.vue?vue&type=template&id=d6a8dd8e&scoped=true&"
import script from "./CollabCourses.vue?vue&type=script&lang=ts&"
export * from "./CollabCourses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a8dd8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
